var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"filterable":"","clearable":"","loading":_vm.loading,"placeholder":_vm.$t('parkingAreaSelect2.parkingLotPlaceholder')},on:{"change":_vm.handleChange}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.paId,attrs:{"label":item.num,"value":item.paId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }